<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('pacote-kit') }}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="onFecharModal"
                    >
                        {{ $t("cancelar") }}
                    </button>
                    <button
                        class="save-btn"
                        type="button"
                        @click="save"
                    >
                        {{ $t("salvar") }}
                    </button>
                </div>
            </div>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <vs-select
                            :id="generateId(1)"
                            ref="pacoteInput"
                            :title="'pacote-kit'"
                            :options="pacotes"
                            v-model="pacoteproduto.pacote"
                            :search="loadPacotes"
                            :onChange="updatePacote"
                            :placeholder="'pacote-kit'"
                            :invalid="isNull(pacoteproduto.pacote)"
                            :loading="loadingPacote"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <vs-select
                            :id="generateId(2)"
                            ref="tabPrecoInput"
                            :title="'tabela-preco'"
                            :options="tabPrecos"
                            v-model="pacoteproduto.tabPreco"
                            :search="loadTabPrecos"
                            :onChange="updateTabPreco"
                            :placeholder="'tabela-preco'"
                            :invalid="isNull(pacoteproduto.tabPreco)"
                            :loading="loadingTabPreco"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <vs-select
                            :id="generateId(3)"
                            ref="unitMedidaInput"
                            :title="'unidade-medida'"
                            :options="unidadesMedida"
                            v-model="pacoteproduto.unidadeMedida"
                            :search="loadUnidadeMedida"
                            :onChange="updateUnidadeMedida"
                            :placeholder="'unidade-medida'"
                            :invalid="isNull(pacoteproduto.unidadeMedida)"
                            :loading="loadingUnidadeMedida"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(4)"
                            ref="tipoDescontoIput"
                            :searchable="false"
                            :options="tipoDescontoSelect"
                            v-model="pacoteproduto.tipoDesconto"
                            mlLabels
                            title="tipo-desconto"
                            clearable
                            @input="onTipoDescontoChanged"
                            :height="40"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(5)"
                            ref="qtdInput"
                            title="qtde"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.qtd"
                            @input="quantidadeUpdate"
                            :invalid="isNull(pacoteproduto.qtd)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(6)"
                            ref="valorUnitInput"
                            title="valor-unitario"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.valorUnit"
                            @input="valUnitUpdate"
                            :invalid="isNull(pacoteproduto.valorUnit)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(7)"
                            ref="valorCustoInput"
                            title="valor-custo"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.valorCusto"
                            @input="valorCustoUpdate"
                            :invalid="isNull(pacoteproduto.valorCusto)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(8)"
                            ref="valorVenInput"
                            title="valor-venda"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.valorVenda"
                            @input="valorVendaUpdate"
                            :invalid="isNull(pacoteproduto.valorVenda)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(9)"
                            ref="qtdMinInput"
                            title="qtd-minima"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.qtdMin"
                            @input="qtdMinUpdate"
                            :invalid="isNull(pacoteproduto.qtdMin)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(10)"
                            ref="qtdMaxInput"
                            title="qtd-maxima"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.qtdMax"
                            @input="qtdMaxUpdate"
                            :invalid="isNull(pacoteproduto.qtdMax)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(11)"
                            ref="descMaxInput"
                            title="desconto-maximo"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="pacoteproduto.descontoMax"
                            @input="descMaxUpdate"
                            :invalid="isNull(pacoteproduto.descontoMax)"
                            :max="9999999"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PacotekitService from "@/services/vendas/produto/PacoteKitService";
import PacoteKitProdutoValidation from "@/services/validations/vendas/produto/PacoteKitProdutoValidation";
import Message from "@/models/Message";
import { mapState } from 'vuex';

export default {
    props: {
        idProduto: 0,
        selected: {
            type: Object,
            default: () => {}
        },
    },
    assProdutoUnidadeMedidaIntegracao: {
        type: Boolean,
        default: false,
    },
    data() {
        return {
            pacoteservice: new PacotekitService(this.$http, this.$router),
            validation: null,
            isLoading: false,
            msgs: [],
            pacotes:[],
            tabPrecos:[],
            unidadesMedida:[],
            isSaving: false,
            loadingPacote: false,
            loadingUnidadeMedida: false,
            loadingTabPreco: false,
            canSelectPacote: false,
            tipoDescontoSelect: [
                { id: 1, label: "desconto" },
                { id: 2, label: "acrescimo" },
            ],
            pacoteproduto: {
                valorUnit: 0,
                valorCusto: 0,
                valorVenda: 0,
                qtdMin: 0,
                qtdMax: 0,
                descontoMax: 0,
                qtd: 0,
                idProduto: 0,
                pacote: null,
                tabPreco: null,
                unidadeMedida: null,
                tipoDesconto: { id: 1, label: "desconto" },
            },
            isUpdate: false,
            situacoes: [{ label: "inativo", id: 0 }, { label: "ativo", id: 1 }],
            situacao: { label: "ativo", id: 1 }
        };
    },
    created() {
        if(this.selected){
            this.isUpdate = true;
            this.loadAssPacoteProduto()
        } else {
            this.carregarDados()
        } 
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        carregarDados() {
            this.validation = new PacoteKitProdutoValidation(this.msgs)

            this.loadPacotes();
            this.loadTabPrecos();
            this.loadUnidadeMedida();
        },
        save() {
            this.isLoading = true;
            let pacoteTemp = this.mapOnSave();
            pacoteTemp = this.mapTosave(pacoteTemp);
            if(this.validation.validate(pacoteTemp, this.$refs)){
                this.isSaving = true;
                this.pacoteservice.savePacoteProduto(pacoteTemp)
                    .then(value => {
                        if (value.content) {
                            let msg = this.$t("msg-save-sucesso-n", { n: this.$t("pacote-kit") });
                                this.msgs.push(new Message("success", msg, true, false));
                                this.onFecharModal(2)
                        } else {
                            if (this.$t(value.message)) {
                                let msgErro = this.$t(value.message);
                                this.msgs.push(new Message("error", msgErro, true, false));
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true, false)
                                );
                            }
                            this.isSaving = false;
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            }else{
                this.isSaving = false;
                this.isLoading = false;
            }
        },
        mapOnSave(){
            return {
                idpacote: this.isNull(this.pacoteproduto.pacote) ? null : this.pacoteproduto.pacote.id,
                idtabpreco: this.isNull(this.pacoteproduto.tabPreco) ? null : this.pacoteproduto.tabPreco.id,
                tipodesconto: this.isNull(this.pacoteproduto.tipoDesconto) ? null : this.pacoteproduto.tipoDesconto.id,
                idunidademedida: this.isNull(this.pacoteproduto.unidadeMedida) ? null : this.pacoteproduto.unidadeMedida.id,

                idpacoteproduto: this.pacoteproduto.idpacoteproduto,
                idproduto: this.idProduto,
                valorunitario: this.pacoteproduto.valorUnit,
                qtde: this.pacoteproduto.qtd,
                valorcusto:this.pacoteproduto.valorCusto,
                valortabpreco: this.pacoteproduto.valorVenda,
                qtdemaximo:this.pacoteproduto.qtdMax,
                qtdeminimo:this.pacoteproduto.qtdMin,
                percdesconto:this.pacoteproduto.descontoMax,
                situacao: 1
            };
        },
        mapPacoteProduto(pp){
            this.pacoteproduto = {
                pacote: !this.isNull(pp.pacote) ? {label: pp.pacote.descricao, id: pp.idpacote} : null,
                tabPreco: !this.isNull(pp.tabPreco) ? {label: pp.tabPreco.descricao, id: pp.idtabpreco} : null,
                unidadeMedida: !this.isNull(pp.unidademedida) ? {label: pp.unidademedida.descricao, id: pp.idunidademedida} : null,

                idpacoteproduto: pp.idpacoteproduto,
                valorUnit: pp.valorunitario,
                valorCusto: pp.valorcusto,
                valorVenda: pp.valortabpreco,
                qtdMin: pp.qtdeminimo,
                qtdMax: pp.qtdemaximo,
                descontoMax: pp.percdesconto,
                qtd: pp.qtde,
                idProduto: pp.idproduto,
                tipoDesconto: pp.tipodesconto == 1 ? { id: 1, label: "desconto" }: { id: 2, label: "acrescimo" },
            }
        },
        onTipoDescontoChanged(val) {
            this.pacoteproduto.tipoDesconto = val;
        },
        loadAssPacoteProduto() {
            this.loadingPacote = true
            this.pacoteservice
                .findIdAssPacoteProduto(this.selected.idpacoteproduto)
                .then((body) => this.mapPacoteProduto(body.content))
                .finally(() => {
                    this.isLoading = false
                    this.carregarDados();
                })
        },
        loadPacotes() {
            this.loadingPacote = true
            this.pacoteservice
                .findAllComboPacote(this.idProduto, 50)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idpacote,
                            label: m.descricao,
                        };
                    });
                })
                .then(allpacotes => {
                this.pacotes = allpacotes;
                this.pacotes.sort();
                if (this.pacoteproduto.pacote && this.pacoteproduto.pacote.obj) {
                    this.updatePacote(
                    this.pacotes.filter(
                        sg => sg.obj.idpacote == this.pacoteproduto.pacote.obj.idpacote
                    )[0]
                    );
                }
                }, 350)
                .finally(() => {
                    this.loadingPacote = false
                })
        },
        loadTabPrecos() {
            this.loadingTabPreco = true
            //arrumar
            this.pacoteservice
                .findAllComboTabPreco(50)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idtabpreco,
                            label: m.descricao,
                        };
                    });
                })
                .then(allTabsPrecos => {
                this.tabPrecos = allTabsPrecos;
                }, 350)
                .finally(() => {
                    this.loadingTabPreco = false
                })
        },
        loadUnidadeMedida() {
            this.loadingUnidadeMedida = true;
            this.pacoteservice
                .findAllComboUnidadeMedida(50, this.$route.params.id, 2)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idunidademedida,
                            label: m.descricao,
                        };
                    });
                })
                .then(allUnidadeMedida => {
                    this.unidadesMedida = allUnidadeMedida;
                    this.unidadesMedida.sort();
                    if((!this.unidadesMedida || this.unidadesMedida.length == 0) && (!this.pacoteproduto.unidadeMedida || this.pacoteproduto.unidadeMedida.id == 0)){
                        const unidademedidavazia = { id: 0, label: this.$t("sem-unidade-medida") };
                        this.updateUnidadeMedida(unidademedidavazia);
                    } else if (this.pacoteproduto.unidadeMedida) {
                        this.updateUnidadeMedida(
                            this.unidadesMedida.filter(
                                sg => sg.id == this.pacoteproduto.unidadeMedida.id
                            )[0]
                        );
                    } else if(this.unidadesMedida && this.unidadesMedida.length != 0 && !this.isUpdate){
                        this.updateUnidadeMedida(this.unidadesMedida[0])
                    } else {
                        const unidademedidavazia = { id: 0, label: this.$t("sem-unidade-medida") };
                        this.updateUnidadeMedida(unidademedidavazia);
                    }
                }, 350)
                .finally(() => {
                    this.loadingUnidadeMedida = false
                })
        },
        updatePacote(pacote) {
            if (pacote) {
                this.pacoteproduto.pacote = pacote;
            } else {
                this.pacoteproduto.pacote = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateTabPreco(tabPreco) {
            if (tabPreco) {
                this.pacoteproduto.tabPreco = tabPreco;
            } else {
                this.pacoteproduto.tabPreco = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateUnidadeMedida(unidadeMedida) {
            if (unidadeMedida) {
                this.pacoteproduto.unidadeMedida = unidadeMedida;
            } else {
                this.pacoteproduto.unidadeMedida = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        onFecharModal(time = 2){
            setTimeout(() => {
                this.$emit('fecharModal',true);
            }, time * 1000 + 50);
        },
        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },

        quantidadeUpdate(value){
            this.pacoteproduto.qtd = value;
        },
        valUnitUpdate(value){
            this.pacoteproduto.valorUnit = value;
        },
        valorCustoUpdate(value){
            this.pacoteproduto.valorCusto = value;
        },
        valorVendaUpdate(value){
            this.pacoteproduto.valorVenda = value;
        },
        qtdMinUpdate(value){
            this.pacoteproduto.qtdMin = value;
        },
        qtdMaxUpdate(value){
            this.pacoteproduto.qtdMax = value;
        },
        descMaxUpdate(value){
            this.pacoteproduto.descontoMax = value;
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
